import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const TermSheetScheduleRefreshModalUI = ({
  context,
  isOpen,
  onCancel,
  onConfirm,
  submitted,
  successMsg,
  errorList,
  setErrorList,
}) => (
  <ModalFormUI
    context={context}
    titleLabel='Refresh schedule from master'
    buttonLabel='Refresh schedule'
    cancelLabel='Cancel'
    isOpen={isOpen}
    onRequestClose={onCancel}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onConfirm}
    busy={submitted}
  >
    <p className='g_m_top_25'>
      This will remove all schedule rows on this loan and copy a fresh set from the
      master term sheet template. Any loan-specific edits to this schedule will be lost. This cannot be undone.
    </p>
  </ModalFormUI>
)

export default TermSheetScheduleRefreshModalUI
